import React from 'react';
import { Button, Currency, FlexRow, Grid, SpaceWrapper } from 'ui-toolkit';
import { AmountText } from '../AmountText';
import { escrowTableSize } from '../escrowTableSize';
import GrayLine from '../../../../shared/GrayLine';
import { ePayee } from '../../../../../types/order/escrow/IDueTo';
import { SpaAddOutgoingButton } from '../SpaAddOutgoingButton';

interface IDueToSellerProps {
  amount: number;
  payee: ePayee;
  isHidden: boolean;
  hideDueToSeller: () => void;
  hideDueToBorrower: () => void;
  onAddTransaction: (fieldName: string, amount: number, cdItemId: string) => void;
}

export const SpaDueTo: React.FC<IDueToSellerProps> = ({
  amount,
  payee,
  isHidden,
  hideDueToSeller,
  hideDueToBorrower,
  onAddTransaction,
}) => {
  if (amount <= 0) {
    return <></>;
  }
  const label = payee;
  const sellerLabels = [ePayee.DueToSeller, ePayee.DueToUnison];
  const createAction = sellerLabels.indexOf(payee) >= 0 ? hideDueToSeller : hideDueToBorrower;
  const onClick = () => {
    createAction();
  };
  return (
    <>
      {isHidden ? null : (
        <>
          <GrayLine />
          <SpaceWrapper topSpace={'roomy'} bottomSpace={'roomy'} leftSpace={'none'} rightSpace={'none'}>
            <Grid columnWidth={escrowTableSize} alignItems={`center`}>
              <div>{label}</div>
              <AmountText>
                <Currency value={amount} />
              </AmountText>
              <FlexRow>
                <SpaAddOutgoingButton
                  amount={amount}
                  cdItemId={''}
                  onHideCDItem={createAction}
                  onAddTransaction={onAddTransaction}
                />
                <Button type={'button'} intent={'ghost'} isInline onClick={onClick}>
                  Hide
                </Button>
              </FlexRow>
            </Grid>
          </SpaceWrapper>
        </>
      )}
    </>
  );
};
